export const BASE_URL = 'https://baeland-api-2.herokuapp.com'